import { useDynatraceRouteTracking } from './hooks/useDynatraceRouteTracking';
import { useIdentifyUserInDynatrace } from './hooks/useIdentifyUserInDynatrace';

export const DynatraceProvider = () => {
	useIdentifyUserInDynatrace();
	useDynatraceRouteTracking();

	return null;
};
